import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import cx from 'classnames';

import Heading from './heading/LEGACY_Heading';
import Link from './link/LEGACY_Link';
import styles from './LEGACY_Markdown.pcss';

/* Default renderer will "unwrap" disallowed tags
   so their text content still shows.
   Works more reliably than ReactMarkdown's `unwrapDisallowed` prop. */
const DEFAULT_RENDERER = ({children, alt, value}) => children || value || alt;

const DEFAULT_RENDERERS = {
    /* Supported tags with custom components */
    heading: Heading,

    /* Unsupported tags */
    image: DEFAULT_RENDERER,
    link: DEFAULT_RENDERER,
    blockquote: DEFAULT_RENDERER,
    inlineCode: DEFAULT_RENDERER,
    code: DEFAULT_RENDERER
};

const DISALLOWED_TYPES = ['thematicBreak'];

class LegacyMarkdown extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        hasLink: PropTypes.bool,
        source: PropTypes.string.isRequired
    };

    static defaultProps = {
        hasLink: false
    };

    render() {
        const {className, hasLink, source} = this.props;
        const wrapperClassName = cx(styles.wrapper, className);

        let renderers = DEFAULT_RENDERERS;
        if (hasLink) {
            renderers = {
                ...DEFAULT_RENDERERS,
                link: Link
            };
        }

        return (
            <ReactMarkdown
                className={wrapperClassName}
                disallowedTypes={DISALLOWED_TYPES}
                renderers={renderers}
                skipHtml
                source={source}
                plugins={[[RemarkBreaks]]}
            />
        );
    }
}

export default LegacyMarkdown;
